<!-- 
<app-welcome-safety-induction></app-welcome-safety-induction>
<app-safety-video></app-safety-video>
<app-thanks-watching></app-thanks-watching>
<app-complete-safety-induction></app-complete-safety-induction>
  -->
<app-header></app-header>
<router-outlet></router-outlet>
<!-- <app-footer></app-footer> -->